import Root from './Root.vue';
import ItemGroup from './ItemGroup.vue';
import Item from './Item.vue';
import IndicatorGroup from './IndicatorGroup.vue';
import Indicator from './Indicator.vue';
import Control from './Control.vue';
import PrevTrigger from './PrevTrigger.vue';
import NextTrigger from './NextTrigger.vue';
import Context from './Context.vue';

export const Carousel = {
  Root,
  ItemGroup,
  Item,
  IndicatorGroup,
  Indicator,
  PrevTrigger,
  NextTrigger,
  Control,
  Context,
};

export * from './types';
